export function validation() {
  const wpcf7Elm = document.querySelectorAll(".wpcf7");
  [...wpcf7Elm].map(anyForm => {
    anyForm.addEventListener("wpcf7invalid", function() {
      const inputWrap = anyForm.querySelectorAll(".input-wrap");
      [...inputWrap].map(item => {
        if (item.querySelector(".wpcf7-not-valid")) {
          item.classList.add("not-valid-field");
        } else {
          if (item.classList.contains("not-valid-field")) {
            item.classList.remove("not-valid-field");
          }
        }
      });
    }, false);
  });
}



// WEBPACK FOOTER //
// ./assets/js/modules/validation.js